<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Overview">

        <p>Your uploaded Lessons are listed here</p>
        <p>Lesson categories are a way to group your lessons for faster sorting and use. You can name your category based on terms, weeks or topics etc</p>
        
        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <div class="demo-alignment">
              <vs-button color="primary" type="line" :disabled="!categories.length">
                <router-link to="/lesson/new">Add Lesson</router-link>
              </vs-button>
              <vs-button @click="newCategoryPopup=true" color="primary" type="line">Add Category</vs-button>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <div class="demo-alignment">
              <vs-button type="line" line-origin="right" color="dark" @click="openFilter = true" icon-pack="feather" icon="icon-filter">Filter</vs-button>
            </div>
          </vs-col>
        </vs-row>
    </vx-card>

    <br>

    <vx-card title="Lessons">
      <div slot="no-body" class="mt-4">
        <vs-table :data="lessons" class="table-dark-inverted">
          <template slot="thead">
            <vs-th>SUBJECT</vs-th>
            <!-- <vs-th>CLASS</vs-th> -->
            <vs-th>CATEGORY</vs-th>
            <vs-th>TITLE</vs-th>
            <vs-th>DATE</vs-th>
            <vs-th>MORE</vs-th>
          </template>
          <template ssslot-scope="{data}">

            <!-- <vs-tr :key="indextr" v-for="(tr, indextr) in data"> -->
            <vs-tr v-for="l in lessons" :key="l.id">
              <vs-td :data="l.id">
                <span>{{ subjects[l.subj_id].name }}</span>
                <br>
                <small>
                  <span v-for="(v) in l.class" :key="v">
                    <span class="mb-2">{{ (classes[v]) ? classes[v].short_name : '-' }} &nbsp; </span>
                  </span>
                </small>
              </vs-td>
              <!-- <vs-td :data="l.id">
                <span v-for="(v) in l.class" :key="v">
                  <span class="mb-2">{{ (classes[v]) ? classes[v].short_name : '-' }} . </span>
                </span>
              </vs-td> -->
              <vs-td :data="l.id">
                <span>{{ l.category }}</span>
              </vs-td>
              <vs-td :data="l.id">
                <!-- <router-link :to="{ path: `/lesson/view/${data[indextr].id}` }"> -->
                <router-link :to="{ path: `/lesson/view/${l.id}` }">
                  <span>{{ l.lesson_title }}</span>
                </router-link>
              </vs-td>
              <vs-td :data="l.id">
                <!-- <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + data[indextr].statusColor"></div>{{data[indextr].title}}</span> -->
                {{ l.updatedAt | moment("MMM Do, YYYY") }}<br>
                <!-- <small>{{ l.staff_title }} {{ l.first_name }} {{ l.last_name }}</small> -->
              </vs-td>
              <vs-td :data="l.id">
                -
                <!-- <span>{{data[indextr].estDelDate}}</span> -->
              </vs-td>
            </vs-tr>

          </template>
        </vs-table>
      </div>
    </vx-card>

    <br>
    <br>

    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <!-- <div class="vx-col w-full">
        <vx-card title="Lessons">
          <div slot="no-body" class="mt-4">
            <vs-table :data="lessons" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>ORDER NO.</vs-th>
                <vs-th>TITLE</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th>LOCATION</vs-th>
                <vs-th>DISTANCE</vs-th>
                <vs-th>START DATE</vs-th>
                <vs-th>EST DELIVERY DATE</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].id">
                    <router-link :to="{ path: `/lesson/view/${data[indextr].id}` }">
                      <span>{{data[indextr].id}}</span>
                    </router-link>
                  </vs-td>
                  <vs-td :data="data[indextr].title">
                    <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + data[indextr].statusColor"></div>{{data[indextr].title}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <ul class="users-liked user-list">
                        <li v-for="(user, userIndex) in data[indextr].usersLiked" :key="userIndex">
                            <vx-tooltip :text="user.name" position="bottom">
                                <vs-avatar :src="user.img" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                            </vx-tooltip>
                        </li>
                    </ul>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].location}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].distance}}</span>
                    <vs-progress :percent="data[indextr].distPercent" :color="data[indextr].statusColor"></vs-progress>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].startDate}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].estDelDate}}</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

        </vx-card>
      </div> -->
    </div>


    <vs-prompt
      title="Filter Lesson"
      @accept="getLesson"
      :active.sync="openFilter">
      <div class="con-exemple-prompt">

        <v-select :options="options.classes" v-model="filter.class" placeholder="Select Class" class="mb-5"  />
        <v-select :options="options.subjects" v-model="filter.subject" placeholder="Select Subject" class="mb-5"  />
        <v-select :options="options.categories" v-model="filter.category" placeholder="Select Category" class="mb-5"  />
      </div>
    </vs-prompt>


    <vs-popup class="holamundo" title="New Lesson Category" :active.sync="newCategoryPopup">
      <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-input class="w-full" icon-pack="feather" icon="icon-book" icon-no-border label="Category Name" v-model="categoryname" />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="addNewCategory">Submit</vs-button>
      </div>
    </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      filter: {
        class: null,
        subject: null,
        category: null
      },
      options: {
        subjects: [],
        classes: [],
        categories: []
      },
      openFilter: false,
      lessons: [],
      categoryname: null,
      newCategoryPopup: false
    }
  },
  computed: {
    subjects () {
      return this.$store.state.academics.subjects
    },
    classes () {
      return this.$store.state.academics.classes
    },
    categories () {
      return this.$store.state.academics.categories
    },
    assigned () {
      return this.$store.state.academics.assigned
    }
  },
  methods: {
    addNewCategory () {
      if (this.categoryname) {
        this.$http.post('/lms/st/lesson/category', { name: this.categoryname }).then((response) => {
          if (response && response.data && response.data.data) {
            // refresh category listing
            this.newCategoryPopup = false
            this.$store.dispatch('academics/fetchCategories')
          }
        }).catch((error) => { 
          console.log(error)
        })
      }
    },

    getLesson () {
      const filter = {
        class: (this.filter.class) ? this.filter.class.id : null,
        subject: (this.filter.subject) ? this.filter.subject.id : null,
        category: (this.filter.category) ? this.filter.category.id : null
      }

      this.$http.get('/lms/st/lesson', { params: filter }).then((response) => {
        if (response && response.data && response.data.data) {
          this.lessons = response.data.data
        }
      }).catch((error) => { 
        console.log(error)
      })
    }
  },
  created () {
    this.getLesson()
    if (!this.subjects) this.$store.dispatch('academics/fetchSubjects')
    if (!this.classes) this.$store.dispatch('academics/fetchClasses')
    if (!this.categories) this.$store.dispatch('academics/fetchCategories')
    if (!this.assigned) this.$store.dispatch('academics/fetchAssigned')

    this.categories.forEach((v) => {
      this.options.categories.push({ label: v.name, id: v.id })
    })

    const tracker = { subj: {}, class: {} }
    this.assigned.forEach((v) => {
      if (!tracker.subj[v.subj_id]) {
        this.options.subjects.push({ label: v.name, id: v.subj_id })
      }

      if (!tracker.class[v.class_id]) {
        this.options.classes.push({ label: v.class_name, id: v.class_id })
      }

      tracker.subj[v.subj_id] = 1
      tracker.class[v.class_id] = 1
    })
  },
  mounted () {
    this.isMounted = true
  }
}
</script>